import {
  ServicesSection,
  RecentProjectsSection,
  HowItWorksSection,
  BookOurService,
} from "shared/sections";
import { ExpertNumbersSection, OurTeam } from "./components";

import "./styles.scss";

const AboutUs = () => (
  <>
    <ExpertNumbersSection />
    <ServicesSection />
    <RecentProjectsSection />
    <HowItWorksSection />
    <OurTeam />
    <BookOurService />
  </>
);

export default AboutUs;
